export default __webpack_public_path__ + "static/banner-finance-why-generation-y-8254d4325d2ba794c42bdc6240035eb9.jpg";